import bg2 from '../../imgs/test2.avif'

import { useTranslation } from 'react-i18next'

import './home.scss'

function Home() {
  const { t } = useTranslation()
  
  return (
    <div className='page-home'>
      <div className='bg-img' style={{ backgroundImage: `url(${bg2})` }}/>
      <div className='home-title'>
        <div className='title-text'>{t('home.title')}</div>
        <div className='title-subText'>{t('home.subTitle')}</div>
      </div>
      <div className='home-counter'>
        <div className='counter-item'>
          <div className='item-count'>{t('home.counter.experience.count')}</div>
          <div className='item-title'>{t('home.counter.experience.title')}</div>
        </div>
        <div className='counter-item'>
          <div className='item-count' style={{ fontSize: '18px' }}>{t('home.counter.codeExperience.count')}</div>
          <div className='item-title'>{t('home.counter.codeExperience.title')}</div>
        </div>
        <div className='counter-item'>
          <div className='item-count'>{t('home.counter.projects.count')}</div>
          <div className='item-title'>{t('home.counter.projects.title')}</div>
        </div>
      </div>
    </div>
  )
}

export default Home
